module.exports = __webpack_public_path__ + "img/wa.4e7f237c.svg";